export function TheAmbassadorIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="24" cy="14" r="6" />
      <path d="M14 38c0-6 4-12 10-12s10 6 10 12" />
      <path d="M8 30c4-2 8-1 10 2" />
      <path d="M40 30c-4-2-8-1-10 2" />
      <path d="M8 30c-2-4-2-8 0-10" />
      <path d="M40 30c2-4 2-8 0-10" />
    </svg>
  );
}
